document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.location-filter-button').forEach(function(button) {
        button.addEventListener('click', function() {
            const filter = this.getAttribute('data-country');
            document.querySelectorAll('.location-item').forEach(function(item) {
                if (filter === 'all' || item.getAttribute('data-country') === filter) {
                    item.style.display = 'flex';
                } else {
                    item.style.display = 'none';
                }});

                document.querySelectorAll('.location-filter-button').forEach(function(btn) {
                 btn.classList.remove('active');
               });
             this.classList.add('active');
         });

        
    })
});
   